import { AnaColumn } from "../forms-template.service";
import { createGridConfig, gridSimple } from "./gridSettings/gridSettings";
export const magazzinorifiuticer: AnaColumn[] = [
  {
    itemType: "group", class: '', colCount: "1", data: [
      


     
     
      { type: 'campo', dataField: "id", colVisible: false, dataType: "", caption: "ID", hideOnEdit: true },

      { type: 'campo', dataField: "idMagazzinoRifiuti", colVisible: false, disableOnUpdate: true },

      {
        type: 'campoSpecial',
        dataField: 'cer',
        dataType: '',
        caption: 'EER',
        showClearButton:false,
        orderGriglia: 1,
        maxLength: '8',
        colVisible: true,
        colWidth:'90', 
        labelVisible: true,
       
        validation: [
          { type: 'required', message: 'Campo EER obbligatorio' }
        ],
        dynamic: {
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          filterStatic:"?$filter=(not endswith(id,'00'))",
          valueExpr: 'id',
          displayExpr: '', //Possibile inserire anche un array di campi da far apparire a video separati da - 
          caption: 'LISTA EER',
          componentType: 'dynamicGrid',
    
          buttonOption: {
            text: 'Codici CER',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista codici CER',
            name: 'CodiciCERLista',
            location: 'after',
          },
          settingGrid:gridSimple
        }
      },



     /*  {
        type: 'campo',
        dataField: "cerDescrizione",
        caption: 'Descrizione',
        colVisible: true,
        cellTemplate: true,
        disableOnUpdate: true,
        hideOnEdit: true,
        allowEditing:false,
        width: 300,
       
      }, */
      {
        type: 'campo',
        dataField: "riferimentoCer",
        colVisible: true,
        dataType: "",
        maxLength:'10',
        caption: "Rif.EER",
        colWidth:'100', 
        showClearButton:false,
      },
      {
        type: 'campoSpecial',
        dataField: "idStatoFisico",
        colVisible: true,
        dataType: "text",
        colWidth:'60',
        caption: "S.F",
        
        showClearButton:false,
        dynamic:{
          valueExpr: 'id',
          displayExpr: 'id',
          dataSource: 'StatoFisico',
          service:'generic',
          componentType: 'dynamicGrid',
          autocomplete:false,
          
          buttonOption: {
            text: 'Stati Fisici',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Stati Fisici',
            name: 'CodiceStatoFisico',
            location: 'after',
          },
          settingGrid: gridSimple

        }
      },
    ]
  },
  {
    itemType: "group", caption: '', class: 'marginRightXX', colCount: "2", colSpan: "1", data: [
      {
        type: 'campo', editorType: 'dxNumberBox', dataType: "number", maxLength: "9", dataField: "maxGiacenza", caption: "Max giacenza[GG]",
        colVisible: true, format: '#0.###', helpText: '(kg)',
       colWidth:'140',showClearButton:false,
        validation: [
          { type: "range", min: '0', max: '999999999999.999999', message: "Valore troppo grande" }
        ],
      },
      {
        type: 'campo', editorType: 'dxNumberBox', dataType: "number", maxLength: "9", dataField: "preavvisoGiacenza", caption: "Avvisa a Kg ",
        colVisible: true, format: '#0.###', helpText: '(kg)',
        colWidth:'118',showClearButton:false,
        validation: [
          { type: "range", min: '0', max: '999999999999.999999', message: "Numero troppo grande" }
        ],
      },
      {
        type: 'campo', editorType: 'dxNumberBox', dataType: "number", maxLength: "3", dataField: "maxGiorniGiacenza", caption: "Tempo max[GG]",
        colVisible: true, helpText:'(GG)',colWidth:'124',showClearButton:false,
        validation: [
          { type: "range", min: '0', max: '99999', message: "Valore troppo grande" }
        ],
      },

      {
        type: 'campo', editorType: 'dxNumberBox', dataType: "number", maxLength: "3", dataField: "giorniPreavviso", caption: "Preaviso[GG]",
        colVisible: true, helpText: '(GG)',showClearButton:false,
        colWidth:'118',
        validation: [
          { type: "range", min: '0', max: '99999', message: "Valore troppo grande" }
        ],
      },
      {
        type: 'campo', editorType: 'dxNumberBox', dataType: "number", maxLength: "9", dataField: "maxCaricoAnno", caption: "Carico Max[Kg]",
        colVisible: true, mask: '##0.0', helpText: '(kg)',showClearButton:false,
        colWidth:'118',
        validation: [
          { type: "range", min: '0', max: '999999999999.999999', message: "Valore troppo grande" }
        ],
      },
      {
        type: 'campo', editorType: 'dxNumberBox', dataType: "number", maxLength: "9", dataField: "preavvisoCaricoAnno", caption: "Avvviso a Kg",
        colVisible: true, mask: '##0.0', helpText: '(Kg)',showClearButton:false,
        colWidth:'118',
        validation: [
          { type: "range", min: '0', max: '999999999999.999999', message: "Valore troppo grande" }
        ],
      },
    ]
  }
];